import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PROVINCE, COMUNI, CATEGORIE, CONTRATTI, ORDINI } from "@/lib/data";

const Field = ({ label, children, light }) => (
  <label className="block">
    <span className={`block mb-1 text-[15px] ${light ? "text-white" : "text-[#666]"}`}>{label}</span>
    {children}
  </label>
);

const Sel = ({ value, onChange, options, placeholder, testid }) => (
  <select className="iv-select" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}>
    <option value="">{placeholder}</option>
    {options.map((o) => {
      const v = typeof o === "string" ? o : o.v;
      return <option key={v} value={v}>{typeof o === "string" ? (PROVINCE.includes(o) ? o.charAt(0) + o.slice(1).toLowerCase() : o) : o.l}</option>;
    })}
  </select>
);

export const SearchForm = ({ initial = {}, vertical = false, light = false }) => {
  const nav = useNavigate();
  const [f, setF] = useState({ contratto: "", categoria: "", provincia: "", comune: "", prezzo_max: "", riferimento: "", ordine: "", ...initial });
  const set = (k) => (v) => setF((s) => ({ ...s, [k]: v }));

  const submit = (e) => {
    e.preventDefault();
    const p = new URLSearchParams();
    Object.entries(f).forEach(([k, v]) => { if (v) p.set(k, v); });
    nav(`/immobili${p.toString() ? `?${p}` : ""}`);
  };

  return (
    <form onSubmit={submit} data-testid="search-form"
      className={vertical ? "space-y-4" : "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-5 gap-y-4 items-end"}>
      <Field light={light} label="Contratto"><Sel testid="search-contratto-select" value={f.contratto} onChange={set("contratto")} options={CONTRATTI} placeholder="Tutti" /></Field>
      <Field light={light} label="Categoria"><Sel testid="search-categoria-select" value={f.categoria} onChange={set("categoria")} options={CATEGORIE} placeholder="Tutte" /></Field>
      <Field light={light} label="Provincia"><Sel testid="search-provincia-select" value={f.provincia} onChange={set("provincia")} options={PROVINCE} placeholder="Scegli" /></Field>
      <Field light={light} label="Comune"><Sel testid="search-comune-select" value={f.comune} onChange={set("comune")} options={COMUNI} placeholder="Scegli" /></Field>
      <Field light={light} label="Prezzo max">
        <input className="iv-input" type="number" min="0" value={f.prezzo_max} onChange={(e) => set("prezzo_max")(e.target.value)} data-testid="search-prezzo-input" />
      </Field>
      <Field light={light} label="Riferimento">
        <input className="iv-input" value={f.riferimento} onChange={(e) => set("riferimento")(e.target.value)} data-testid="search-riferimento-input" />
      </Field>
      <Field light={light} label="Ordine"><Sel testid="search-ordine-select" value={f.ordine} onChange={set("ordine")} options={ORDINI.slice(1)} placeholder="Rilevanza" /></Field>
      <button type="submit" data-testid="search-submit-button"
        className="w-full h-10 bg-[var(--iv)] text-white text-lg rounded-[3px] hover:bg-[var(--iv-dark)] transition-colors shadow">
        Avvia la ricerca
      </button>
    </form>
  );
};
